<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">

        <div class="widget-heading mb-3 border-bottom pb-2">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="my-0 me-3"><strong>Lista pracowników</strong></h4>

            <div class="d-flex gap-2">
              <Link :href="route('kadry.add.user')" class="btn btn-outline-primary">
                <i class="bi bi-plus-circle"></i>&nbsp;Dodaj pracownika
              </Link>
              <a :href="route('export.pracownicy')" class="btn btn-success" download>
                <i class="bi bi-file-earmark-excel"></i>&nbsp;Wszyscy Excel
              </a>
              <a :href="route('export.pracownicy.pdf')" class="btn btn-info" target="_blank">
                <i class="bi bi-file-earmark-pdf"></i>&nbsp;Wszyscy PDF
              </a>
              <a :href="route('export.pracownicy.activ.excel')" class="btn btn-success" download>
                <i class="bi bi-file-earmark-excel"></i>&nbsp;Aktywni Excel
              </a>
              <a :href="route('export.pracownicy.activ')" class="btn btn-info" target="_blank">
                <i class="bi bi-file-earmark-pdf"></i>&nbsp;Aktywni PDF
              </a>
              <a :href="route('export.pracownicy.adresy.excel')" class="btn btn-success" target="_blank">
                <i class="bi bi-file-earmark-excel"></i>&nbsp;Wszyscy (adresy) Excel
              </a>
              <a :href="route('export.pracownicy.adresy.pdf')" class="btn btn-info" target="_blank">
                <i class="bi bi-file-earmark-pdf"></i>&nbsp;Wszyscy (adresy) PDF
              </a>
			  </div>
          </div>
        </div>

        <div class="widget-content me-1">
          <div class="table-responsive">
            <table id="data-table" ref="dataTable" class="table table-bordered table-hover w-100">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nazwisko i imię</th>
                  <th>Umowa od</th>
                  <th>Umowa do</th>
                  <th>Pierwsza umowa</th>
                  <th>Staż</th>
                  <th>Urlop na {{ year }}</th>
                  <th>Urlop z {{ year - 1 }}</th>
                  <th>Oddział</th>
                  <th>Dział</th>
                  <th>Stanowisko</th>
                  <th>Stanowisko ENG</th>
                  <th>Nr. karty</th>
                  <th>Status</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { onMounted, ref } from 'vue';
import Swal from 'sweetalert2';

export default {
  components: { AppLayout },
  setup() {
    const dataTable = ref(null);
    const today = new Date();
    const year = today.getFullYear();

    function showUmowaWarning(dateStr) {
      if (!dateStr) return false;
      const umowaDate = new Date(dateStr);
      const diffDays = (umowaDate - today) / (1000 * 60 * 60 * 24);
      return diffDays < 30;
    }

    function showToast(icon, title, message) {
      Swal.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }

    onMounted(() => {
      dataTable.value = $('#data-table').DataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [[25, 50, 100, -1], [25, 50, 100, "Wszystkie"]],
        ajax: {
          url: '/kadry/pracownicy',
          type: 'GET',
        },
        columns: [
          { width: "3%", data: 'id', name: 'id' },
          {
            width: "170px",
            data: 'name',
            name: 'name',
            render: function (data, type, row) {
              let rightIcons = '';
              let belowAlerts = '';

              if (row.termin_warning) {
                rightIcons += `<span class="text-warning ms-1" title="Wymagana weryfikacja terminu pracownika!">⚠️</span>`;
              }
              if (!row.umowa_od) {
                belowAlerts += `<br><span class="alert alert-danger alert-xs mt-1" style="padding: 2px 6px; font-size: 0.75rem; line-height: 1;">Brak danych o umowie!</span>`;
              }
              if (row.is_active == 0) {
                belowAlerts = `<br><span class="alert alert-danger alert-xs mt-1 " style="padding: 2px 6px; font-size: 0.75rem; line-height: 1;">Umowa rozwiązana</span>`;
              }

              return `
			  <div style="display:flex; align-items:center; justify-content:space-between;">
				<a href="/kadry/show/user/${row.id}" class="text-primary hover:underline cursor-pointer"><strong>${data}</strong></a>
				${rightIcons}
			  </div>
			  ${belowAlerts}
			`;
            },
			            orderable: false,
          },
          {
            width: "95px",
            data: 'umowa_od',
            name: 'umowa_od',
            className: 'text-center',
            render: function (data, type, row) {
              let warning = '';
              if (!row.umowa_od && row.is_active == 1) {
                warning = `<span class="text-danger text-left" title="Brak daty podpisania umowy!">⚠️</span>`;
              }

              if (!data) return '' + warning;
              return new Date(data).toLocaleDateString('pl-PL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }) + warning;

            },
            defaultContent: ''
          },
          {
            width: "95px",
            data: 'umowa_do',
            name: 'umowa_do',
            className: 'text-center',
            render: function (data, type, row) {
              let warning = '';
              if (showUmowaWarning(data) && row.is_active == 1) {
                warning = `<span class="text-warning text-left" title="Umowa kończy się w mniej niż 30 dni!">⚠️</span>`;
              }
              if (!data) return '' + warning;
              return new Date(data).toLocaleDateString('pl-PL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }) + warning;
            },
            defaultContent: ''
          },
          {
            data: 'pierwsza_umowa',
            name: 'pierwsza_umowa',
            className: 'text-center',
            render: function (data, type, row) {
              if (!data) {
                return '';
              }
              const d = new Date(data);
              return isNaN(d)
                ? ''
                : d.toLocaleDateString('pl-PL', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit'
                });
            },
            defaultContent: '',
            orderable: false,
            searchable: false
          },
          { data: 'stazInfo', name: 'stazInfo', defaultContent: '', orderable: false, searchable: false, className: 'text-center' },
          { width: "90px", data: 'ten_rok', name: 'ten_rok', defaultContent: '', className: 'text-center' },
          { width: "90px", data: 'poprzedni_rok', name: 'poprzedni_rok', defaultContent: '', className: 'text-center' },
          { width: "80px", data: 'oddzial', name: 'oddzial', defaultContent: '' },
          { width: "150px", data: 'dzial', name: 'dzial', defaultContent: '' },
          { data: 'stanowisko', name: 'stanowisko', defaultContent: '' },
          { data: 'stanowisko_en', name: 'stanowisko_en', defaultContent: '' },
           { width: "80px", data: 'nr_karty', name: 'nr_karty', defaultContent: '' },
          {
            width: "50px",
            data: 'is_active',
            name: 'is_active',
            className: 'text-center',
            render: function (data) {
              return data == 1
                ? `<i style="color:green" class="bi bi-check-circle"></i>`
                : `<i style="color:orangered" class="bi bi-x-circle"></i>`;
            }
          },
        ],
        createdRow: function (row, data) {
          const isInactive = data.is_active == 0;
          if (isInactive) {
            $('td', row).css('background-color', '#f8d7da');
          } else if (data.umowa_do != '') {
            $('td', row).css('background-color', '#fff774');
          }
        }
      });

      // Edytowanie komórek ten_rok i poprzedni_rok
      $('#data-table tbody').on('click', 'td', function () {
        var table = dataTable.value;
        var cell = table.cell(this);
        var colIndex = cell.index().column;

        if (colIndex === 6 || colIndex === 7) {
          var $td = $(this);
          if ($td.find('input').length > 0) return;

          var originalValue = cell.data() || '';
          var rowData = table.row(cell.index().row).data();

          $td.html('<input type="text" class="form-control form-control-sm w-100 text-center" style="border-radius: 0;" value="' + originalValue + '"/>');
          var $input = $td.find('input');
          $input.focus().select();

          async function save() {
            var newValue = $input.val();
            var what = '';
            if (colIndex == 6) what = 'ten_rok';
            if (colIndex == 7) what = 'poprzedni_rok';

            try {
              await axios.put(route('kadry.urlopy.update.user', rowData.id), {
                what: what,
                val: newValue,
                year: year,
              });
              showToast('success', 'Zapisano', 'Dane zostały zaktualizowane.');
            } catch (err) {
              console.error(err);
              showToast('error', 'Błąd', 'Nie udało się zapisać danych.');
            }

            setTimeout(() => {
              cell.data(newValue).draw(false);

              console.log('id: ', rowData.id);
              console.log('co: ', what);
              console.log('wartosc: ', newValue);
              console.log('rok: ', year);
            }, 10);
          }

          $input.on('blur', save);
          $input.on('keyup', function (e) {
            if (e.key === 'Enter') {
              save();
            } else if (e.key === 'Escape') {
              cell.data(originalValue).draw(false);
            }
          });
        }
      });
    });

    return { dataTable, year };
  }
};
</script>



<style>
.text-warning {
  color: orange;
  font-weight: bold;
}

.text-danger {
  color: red;
  font-weight: bold;
}

.alert-xs {
  font-size: 0.75rem;
  padding: 2px 8px;
  line-height: 1.1;
}

.bg-umowaend {
  background-color: #feffae !important;
}

.bg-noactive {
  background-color: #fbd3d3 !important;
}
</style>
